import {createTheme} from "@mui/material";

 
export const theme = createTheme({
	typography: {
		fontFamily: "var(--fontFamilyBase)",
	},

	palette: {
		primary: {
			main: "#fff",
		},
		secondary: {
			main: "#4187f6",
		},

		grey: {
			"50": "#F2F2F5",
			"100": "#E5E5EA",
			"200": "#C7C7CC",
			"300": "#AEAEB2",
			"400": "#8E8E93",
			"500": "#636366",
			"600": "#48484A",
			"700": "#3A3A3C",
			"800": "#2C2C2E",
			"900": "#1C1C1E",
			A100: "#f5f5f5",
			A200: "#eeeeee",
			A400: "#bdbdbd",
			A700: "#616161",
		},
		error: {
			contrastText: "#fff",
			dark: "rgb(170, 46, 37)",
			light: "rgb(246, 104, 94)",
			main: "#f44336",
		},
		success: {
			contrastText: "rgba(0, 0, 0, 0.87)",
			dark: "rgb(16, 140, 79)",
			light: "rgb(70, 211, 141)",
			main: "#18C971",
		},
		text: {
			disabled: "rgba(0, 0, 0, 0.38)",
			primary: "#101010",
			secondary: "#8E8E93",
		},
	},
	components: {
		MuiButton: {
			defaultProps: {
				disableElevation: true,
			},
			styleOverrides: {
				root: {
					textTransform: "none",
					borderRadius: "100px",
					height: "40px",
					fontWeight: 700,
					fontSize: "16px",
					":disabled": {
						opacity: 0.5,
					},
					":hover": {
						opacity: 0.9,
					},
				},
				contained: {
					color: "#68A3F8",
					background: "#142845",
					":hover": {
						background: "#142845",
					},
					":disabled": {
						opacity: 0.4,
						background: "#142845",
						color: "#68A3F8",
					},
				},
				containedSecondary: {
					color: "#A3DD9E",
					background: "#27552B",
					":hover": {
						background: "#27552B",
					},
					":disabled": {
						opacity: 0.4,
						background: "#27552B",
						color: "#A3DD9E",
					},
					"&[aria-disabled=true]": {
						opacity: 0.4,
						background: "#27552B",
						color: "#A3DD9E",
					},
				},
				containedError: {
					color: "#ffffff",
					background: "#C02525",
					"&:hover": {
						background: "#C02525",
					},
					":disabled": {
						opacity: 0.4,
						background: "#C02525",
						color: "#ffffff",
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					color: "#fff",
					fontFamily: "var(--fontFamilyBase)",
					fontWeight: 700,
					"&.Mui-error": {
						color: "#f44336",
					},
					"&:hover": {
						color: "#fff",
						".MuiOutlinedInput-notchedOutline": {
							border: "1px solid #85898F",
							color: "#fff",
						},
					},
				},
				notchedOutline: {
					border: "1px solid #85898F",
					color: "#fff",
					"&:hover": {
						color: "#fff",
						border: "1px solid #85898F",
					},
				},
				input: {
					fontFamily: "var(--fontFamilySecond)",
					"&.Mui-disabled": {
						color: "#fff",
						borderColor: "#85898F",
						".MuiOutlinedInput-notchedOutline": {
							borderColor: "#85898F",
							color: "#fff",
						},
					},
				},
			},
		},
		MuiTabs: {
			styleOverrides: {
				root: {
					textTransform: "none",
				},
				indicator: {
					height: 4,
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					textTransform: "none",
					fontWeight: 700,
					fontSize: "16px",
					padding: "0 7px",
					minWidth: 0,
					margin: "0 15px",
					"&:first-of-type": {
						marginLeft: "0",
					},
					"&:last-of-type": {
						marginRight: "0",
					},
				},
			},
		},
	},
});
